// The four stops `Zenitho` animates, held still. A browser with no WebGL keeps
// the same palette instead of an empty bar; the patched `Zenitho` renders this
// instead of taking the page down with it. See patches/uvcanvas@0.3.0.patch.
export function ZenithoFallback() {
  return (
    <div
      className='h-full w-full'
      style={{
        backgroundImage:
          'linear-gradient(90deg, #ef008f 0%, #6ec3f4 33%, #7038ff 66%, #ffba27 100%)',
      }}
    />
  );
}
